import sanityClient from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'

// Find your project ID and dataset in `sanity.json` in your studio project
const projectId = process.env.VUE_APP_SANITY_PROJECT
const dataset = process.env.VUE_APP_SANITY_DATASET

// useCdn == true gives fast, cheap responses using a globally distributed cache.
// Set this to false if your application require the freshest possible
// data always (potentially slightly slower and a bit more expensive).
const useCdn =
  (process.env.VUE_APP_SANITY_USE_CDN || '').toLowerCase() === 'true'

const sanity = sanityClient({
  projectId,
  dataset,
  useCdn
})

const imageBuilder = imageUrlBuilder(sanity)
const imageUrlFor = (source) => imageBuilder.image(source)

export default sanity
export { imageBuilder, imageUrlFor }
